import { useState, useEffect, useContext } from "react";
import { db } from "../firebase";
import { UserContext } from "../UserContext";
import PulseLoader from "react-spinners/PulseLoader";
import SensorConfigMenu from "./SensorConfigMenu";
import LineChartV3 from "./LineChartV3";
import BarGraphV3 from "./BarGraphV3";
import DashboardGroup from "./DashboardGroup";

export default function MonitoringV25({ pumpRoomRef }) {
  const [device, setDevice] = useState();
  const [userRef, setUserRef] = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [lastComm, setLastComm] = useState("");
  const [showSensorConfig, setShowSensorConfig] = useState(false);
  const [selectedForLogs, setSelectedForLogs] = useState();
  const [pumps, setPumps] = useState([]);
  const [alarms, setAlarms] = useState([]);
  const [markIIIControllers, setMarkIIIControllers] = useState([]);
  const [multiConditionIndicators, setMultiConditionIndicators] = useState([]);
  const [pressureSensors, setPressureSensors] = useState([]);
  const [selectedForBarGraph, setSelectedForBarGraph] = useState();
  const [dashboardGroups, setDashboardGroups] = useState([]);

  function updateSelectedForLogs(selection) {
    setSelectedForLogs(selection);
  }

  function updateSelectedForBarGraph(selection) {
    setSelectedForBarGraph(selection);
  }

  useEffect(() => {
    if (device) {
      const commDate = new Date(device.lastCommTimestamp.toDate());
      setLastComm(
        new Date(commDate).toLocaleString("en-US", {
          timeZone: "America/New_York",
        })
      );

      let groups = [];

      for (const page of device.dashboardConfig.pages) {
        for (const group of page.groups) {
          groups.push(group);
        }
      }

      setDashboardGroups(groups);
    }
  }, [device]);

  const closeChart = () => {
    setSelectedForLogs();
  };

  const closeGraph = () => {
    setSelectedForBarGraph();
  };

  useEffect(() => {
    setTimeout(() => {
      if (pumpRoomRef.monitoring_enabled === 1) {
        const unsubscribe = db
          .collection("devices")
          .doc(pumpRoomRef.device)
          .onSnapshot((doc) => {
            setDevice(doc.data());
            setLoading(false);
          });

        return () => {
          unsubscribe();
        };
      } else {
        setLoading(false);
      }
    }, [200]);
  }, [pumpRoomRef]);

  useEffect(() => {
    let unsubscribePumps,
      unsubscribeAlarms,
      unsubscribeMarkIII,
      unsubscribeMci,
      unsubscribePressure;

    if (device) {
      unsubscribePumps = db
        .collection("devices")
        .doc(device.id)
        .collection("pumps")
        .where("enabled", "==", true)
        .orderBy("position")
        .onSnapshot((snapshot) => {
          setPumps(snapshot.docs.map((doc) => doc.data()));
        });

      unsubscribeAlarms = db
        .collection("devices")
        .doc(device.id)
        .collection("alarms")
        .where("enabled", "==", true)
        .orderBy("position")
        .onSnapshot((snapshot) => {
          setAlarms(snapshot.docs.map((doc) => doc.data()));
        });

      unsubscribeMarkIII = db
        .collection("devices")
        .doc(device.id)
        .collection("markIIIControllers")
        .where("enabled", "==", true)
        .orderBy("position")
        .onSnapshot((snapshot) => {
          setMarkIIIControllers(snapshot.docs.map((doc) => doc.data()));
        });

      unsubscribeMci = db
        .collection("devices")
        .doc(device.id)
        .collection("multiConditionIndicators")
        .where("enabled", "==", true)
        .orderBy("position")
        .onSnapshot((snapshot) => {
          setMultiConditionIndicators(snapshot.docs.map((doc) => doc.data()));
        });

      unsubscribePressure = db
        .collection("devices")
        .doc(device.id)
        .collection("pressureSensors")
        .where("enabled", "==", true)
        .orderBy("position")
        .onSnapshot((snapshot) => {
          setPressureSensors(snapshot.docs.map((doc) => doc.data()));
        });
    }

    return () => {
      if (unsubscribePumps) unsubscribePumps();
      if (unsubscribeAlarms) unsubscribeAlarms();
      if (unsubscribeMarkIII) unsubscribeMarkIII();
      if (unsubscribeMci) unsubscribeMci();
      if (unsubscribePressure) unsubscribePressure();
    };
  }, [device]);

  function getSensorsForGroup(groupID) {
    const groupPumps = pumps.filter((p) => p.group === groupID);
    const groupAlarms = alarms.filter((a) => a.group === groupID);
    const groupMarkIII = markIIIControllers.filter(
      (m3) => m3.group === groupID
    );
    const groupMci = multiConditionIndicators.filter(
      (m) => m.group === groupID
    );
    const groupPressureSensors = pressureSensors.filter(
      (p) => p.group === groupID
    );

    const sensors = [
      ...groupPumps,
      ...groupAlarms,
      ...groupMarkIII,
      ...groupMci,
      ...groupPressureSensors,
    ];

    sensors.sort((a, b) => a.position - b.position);
    return sensors;
  }

  return (
    <div>
      <PulseLoader
        color={"#ffffff"}
        loading={loading}
        size={20}
        className="loader"
      />
      {loading === false && (
        <div>
          {selectedForLogs || selectedForBarGraph ? (
            <>
              {selectedForLogs ? (
                <LineChartV3
                  deviceID={pumpRoomRef.device}
                  sensorID={selectedForLogs.id}
                  closeChart={closeChart}
                  sensorName={selectedForLogs.name}
                />
              ) : (
                <BarGraphV3
                  deviceID={pumpRoomRef.device}
                  pumpID={selectedForBarGraph.id}
                  closeGraph={closeGraph}
                  inputName={selectedForBarGraph.name}
                />
              )}
            </>
          ) : (
            <>
              {!showSensorConfig ? (
                <div>
                  {pumpRoomRef.monitoring_enabled && device ? (
                    <div>
                      <div className="pumpRoomHeading2">
                        <h2>Monitoring</h2>
                        {/* {userRef.canAccessInputConfig && (
                          <div>
                            <button
                              className="spaceBtn"
                              onClick={() => setShowSensorConfig(true)}
                            >
                              SENSOR CONFIG
                            </button>
                          </div>
                        )} */}
                      </div>
                      {lastComm.length > 0 && (
                        <div className="margin1">
                          <div className="bold sectionSpacer">
                            LAST CHECK-IN:
                          </div>
                          <div>{lastComm}</div>
                        </div>
                      )}
                      {dashboardGroups.length > 0 && (
                        <div className="dashboardGroupsContainer">
                          {dashboardGroups.map((g) => (
                            <DashboardGroup
                              key={g.id}
                              group={g}
                              sensors={getSensorsForGroup(g.id)}
                              updateSelectedForBarGraph={
                                updateSelectedForBarGraph
                              }
                              updateSelectedForLogs={updateSelectedForLogs}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="middleContainer">
                      NO ACTIVE REMOTE MONITORING PLAN
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <div className="pumpRoomHeading2">
                    <h2>Sensor Config</h2>
                    <div>
                      <button
                        className="spaceBtn"
                        onClick={() => setShowSensorConfig(false)}
                      >
                        CLOSE
                      </button>
                    </div>
                  </div>
                  <SensorConfigMenu deviceID={pumpRoomRef.device} />
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
